import {
    GET_FILES,
    GET_FOLDERS,
    SET_SEARCH_JOB_ID,
    SET_PAGE,
    SET_FOLDER,
    SET_ROW,
    UPLOAD_FILE,
    REMOVE_FILE,
    SET_SELECTED,
    MOVE_FILES
} from "./types";

const INITIAL_STATE = {
    requesting: false,
    files: false,
    folders: false,
    dateFrom: false,
    dateTo: false,
    filterStatus: "all",
    searchVal: "",
    rows: 50,
    page: 0,
    activeFolder: "all_files",
    uploading: false,
    removing: false,
    moving: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_FILES.REQUEST: {
            return { ...state, requesting: true, files: false };
        }
        case GET_FILES.FAIL: {
            return { ...state, requesting: false, files: false };
        }
        case GET_FILES.SUCCESS: {
            return { ...state, requesting: false, files: action.payload };
        }
        case GET_FOLDERS.REQUEST: {
            return { ...state, requesting: true, folders: false };
        }
        case GET_FOLDERS.FAIL: {
            return { ...state, requesting: false, folders: false };
        }
        case GET_FOLDERS.SUCCESS: {
            return { ...state, requesting: false, folders: action.payload };
        }
        case UPLOAD_FILE.REQUEST: {
            return { ...state, requesting: true, uploading: true };
        }
        case UPLOAD_FILE.FAIL: {
            return { ...state, requesting: false, uploading: false };
        }
        case UPLOAD_FILE.SUCCESS: {
            return { ...state, requesting: false, uploading: false };
        }
        case REMOVE_FILE.REQUEST: {
            return { ...state, requesting: true, removing: true };
        }
        case REMOVE_FILE.FAIL: {
            return { ...state, requesting: false, removing: false };
        }
        case REMOVE_FILE.SUCCESS: {
            return { ...state, requesting: false, removing: false };
        }
        case MOVE_FILES.REQUEST: {
            return { ...state, requesting: true, moving: true };
        }
        case MOVE_FILES.FAIL: {
            return { ...state, requesting: false, moving: false };
        }
        case MOVE_FILES.SUCCESS: {
            return { ...state, requesting: false, moving: false };
        }
        case SET_SEARCH_JOB_ID: {
            return { ...state, searchVal: action.payload };
        }
        case SET_PAGE: {
            return { ...state, page: action.payload };
        }
        case SET_ROW: {
            return { ...state, rows: action.payload };
        }
        case SET_FOLDER: {
            return { ...state, activeFolder: action.payload };
        }
        case SET_SELECTED: {
            return { ...state, files: action.payload };
        }
        default: {
            return { ...state };
        }
    }
};
